export default {
    "navigation": {
        "allWatchfaces": "Alla appar",
        "faq": "FAQ",
        "helpCenter": "Hjälp och instruktioner",
        "newsletter": "Nyhetsbrev",
        "contact": "Kontakt",
        "weatherProvider": "Väderleverantör",
        "tides": "Tidvatten",
        "colors": "Färger",
        "fonts": "Typsnitt"
    },
    "homepage": {
        "title": "TitanicTurtle Apps",
        "subtitle": "Moderna Garmin-appar med avancerade funktioner för alla dina aktiviteter",
        "features": {
            "tides": "🌊 Tidvatten",
            "weather": "🌤️ Väder",
            "themes": "🎨 Färgteman",
            "gps": "📍 GPS"
        },
        "availableWatchfaces": "Tillgängliga urbrickor",
        "newBadge": "Ny",
        "loading": "Laddar urbrickor …",
        "error": "Fel vid laddning",
        "retry": "Försök igen",
        "filter": {
            "label": "Produktfilter",
            "watchfaces": "Urbrickor",
            "apps": "Appar",
            "all": "Alla",
            "noProducts": "Inga produkter i denna kategori"
        }
    },
    "watchface": {
        "purchase": "Köp nu",
        "buy": "Köp",
        "features": "Funktioner",
        "colorThemes": "Färgteman",
        "themeDescription": "Klicka på ett tema för att kopiera temastrengen och använda den i urbrickans inställningar.",
        "dynamicThemeSwitching": "Dynamiskt temabyte",
        "sunsetSwitching": {
            "title": "🌅 Efter solnedgång / före soluppgång",
            "description": "Sätt ett utropstecken ! framför temastrengen för automatisk växling efter solnedgång (exempel: !UEUE[UEUEEEEEEU^)."
        },
        "lowPowerSwitching": {
            "title": "🔋 I lågenergiläge",
            "description": "Sätt ett # framför temastrengen för lågenergiläge (exempel: #UEUE[UEUEEEEEEU^)."
        },
        "themeCopied": "Temastreng kopierad till urklipp!",
        "viewDetails": "Visa detaljer"
    },
    "faq": {
        "title": "Vanliga frågor",
        "subtitle": "Hitta svar på vanliga frågor om våra urbrickor",
        "tabs": {
            "search": "Sök",
            "categories": "Kategorier",
            "all": "Visa alla FAQ"
        },
        "category": {
            "selected": "Vald kategori",
            "showing": "Visar",
            "items": "objekt",
            "from": "av",
            "clear": "Rensa val",
            "back": "Tillbaka till kategorier"
        },
        "viewAnswer": "Visa svar",
        "closeAnswer": "Stäng svar",
        "darkMode": {
            "enable": "Aktivera mörkt läge",
            "disable": "Inaktivera mörkt läge",
            "light": "Ljust",
            "dark": "Mörkt"
        },
        "search": {
            "placeholder": "Sök efter hjälp …",
            "button": "Sök",
            "suggestions": "Populära sökningar",
            "tips": {
                "title": "Söktips",
                "keywords": "Använd specifika nyckelord som «GPS», «väder» eller «inställningar»",
                "language": "Sökningen fungerar på valt språk",
                "categories": "Bläddra i kategorier för organiserad hjälp"
            }
        },
        "noResults": {
            "title": "Inga resultat hittades",
            "description": "Prova andra nyckelord eller bläddra i kategorier",
            "browseCategories": "Bläddra i kategorier"
        },
        "suggestions": {
            "title": "Populära sökningar"
        },
        "trending": {
            "title": "Populära sökningar just nu"
        },
        "categories": {
            "title": "Bläddra efter kategori",
            "items": "objekt",
            "allItems": "Alla FAQ-poster",
            "allItemsDescription": "Bläddra bland alla vanliga frågor",
            "noItems": {
                "title": "Inga poster i denna kategori",
                "description": "Prova att välja en annan kategori"
            },
            "viewMore": "Visa alla poster"
        },
        "results": {
            "title": "Sökresultat",
            "found": "resultat hittades för",
            "total": "Totalt antal resultat",
            "bestMatch": "Bästa träff",
            "categories": "Kategorier",
            "sortBy": "Sortera efter",
            "sort": {
                "relevance": "Relevans",
                "priority": "Prioritet",
                "category": "Kategori"
            },
            "lastUpdated": "Senast uppdaterad",
            "matchedIn": "Träff i",
            "footer": "Hittade du inte det du letade efter?",
            "browseCategories": "Bläddra i kategorier",
            "viewTrending": "Visa populära sökningar",
            "contactSupport": "Kontakta support"
        },
        "actions": {
            "copy": "Kopiera",
            "share": "Dela",
            "copyAnswer": "Kopiera svar",
            "copyAll": "Kopiera allt"
        },
        "loading": "Laddar FAQ …",
        "error": "Fel vid laddning",
        "retry": "Försök igen",
        "questions": {
            "gpsFix": {
                "question": "Vad är en GPS-fix och hur gör jag det? / Varför visar vissa alternativ «GPS?»",
                "answer": "En GPS-fix behövs så att urbrickan vet var du är och kan beräkna sol- och måntider korrekt.\n\nDu kan göra en GPS-fix genom att starta en aktivitet och vänta tills klockan har GPS-signal, eller genom att hålla inne GPS-knappen tills klockan har signal.\n\nGå sedan tillbaka till urbrickan – allt ska visas korrekt."
            },
            "userData": {
                "question": "Samlar urbrickorna in användardata?",
                "answer": "Inga TitanicTurtle-urbrickor samlar in användardata eller skickar dem vidare. De visar bara data från Garmin eller beräknar utifrån dem (t.ex. aktiva kalorier).\n\nGenerellt är data som Garmin ger till tredjepartsurbrickor inte personliga – det finns t.ex. inget namn att läsa ut."
            },
            "permissions": {
                "question": "Varför behöver urbrickorna så många behörigheter?",
                "answer": "TitanicTurtle Watchfaces behöver behörigheter för att erbjuda det stora utbudet av data och funktioner.\n\nHär är varje enskild förklarad:\n\n<b>Köra i bakgrunden när den inte är aktiv</b> – behövs för att uppdatera tidvatten/väder från tredjepartsleverantörer tillsammans med internetbehörigheten\n\n<b>Skicka/ta emot information till/från internet</b> – behövs för att uppdatera tidvatten/väder tillsammans med bakgrundskörning.\n\n<b>Läsa och visa data från andra appar.</b> – Andra appar måste uttryckligen dela data som urbrickor kan läsa. Detta inkluderar Garmin-appar som Stress eller Body Battery, som kan uppdateras i realtid. Obehörig data från andra appar kan inte läsas.\n\n<b>GPS-plats</b> – behövs för soluppgång/solnedgång, månuppgång/månnedgång och rätt väderplats\n\n<b>Puls, barometer, temperatur och höjdhistorik</b> – data som visas på urbrickan – endast för visning.\n\n<b>Din Garmin Connect™-träningsprofil</b> – behövs för vikt, aktiva kalorier och energisparläge till inställda sömntider.\n\nInga personuppgifter som namn eller adresser kan läsas ut av urbrickor.\n\nTyvärr kan inte behörigheterna ställas in efter hur du använder urbrickan – de krävs alltid."
            },
            "proFeatures": {
                "question": "Vad betyder ♛ och varför visar vissa vyer «key»?",
                "answer": "♛ markerar pro-funktionerna på denna urbricka. Efter 5 dagars provperiod kan du köpa en aktiveringsnyckel.\n\n«key?» betyder att provperioden är slut."
            },
            "temperatureUnits": {
                "question": "Hur ändrar jag temperaturenheter?",
                "answer": "Gå till klockans systeminställningar (håll inne menyknappen): System -> Format -> Enheter, och ändra där."
            },
            "timeFormat": {
                "question": "Hur ställer jag in 12h/24h-format?",
                "answer": "Gå till klockans systeminställningar (håll inne menyknappen): System -> Format -> Tidsformat, och ändra där."
            },
            "distanceUnits": {
                "question": "Hur ändrar jag enheter för avstånd eller höjd?",
                "answer": "Gå till klockans systeminställningar (håll inne menyknappen): System -> Format -> Enheter, och ändra där."
            }
        }
    },
    "helpCenter": {
        "title": "Hjälp och instruktioner",
        "subtitle": "Hitta svar, guider och instruktioner för din urbricka",
        "guidesTitle": "Guider",
        "faqTitle": "Vanliga frågor",
        "allCategories": "Alla",
        "guides": "Guider",
        "faqResults": "FAQ",
        "noResults": "Inga resultat hittades",
        "noResultsHint": "Prova andra sökord eller bläddra i kategorierna och guiderna nedan."
    },
    "guides": {
        "backToHelp": "Tillbaka",
        "purchase": {
            "title": "Köp och installation",
            "tabs": {
                "installation": "Installation",
                "versions": "VX / Elite-versioner",
                "troubleshooting": "Felsökning"
            },
            "installation": {
                "title": "Installera urbrickor via ConnectIQ-appen",
                "intro": "Urbrickor kan installeras på klockan via Garmin ConnectIQ-appen för Android eller iOS.",
                "step1": "Anslut klockan till telefonen via Bluetooth och öppna ConnectIQ-appen på telefonen.",
                "step2": "Gå till sidan för urbrickan du vill installera.",
                "step3": "Tryck på knappen «Installera». Urbrickan läggs i nedladdningskön och installeras på klockan.",
                "step4": "Efter installation visas ett meddelande i appen eller på klockan och urbrickan finns på enheten.",
                "noteScreen": "Se till att telefonskärmen inte stängs av och att ConnectIQ-appen hålls öppen under installation och uppdateringar.",
                "selectWatchfaceTitle": "Välja urbricka på klockan",
                "selectWatchfaceIntro": "Om urbrickan är installerad men inte syns kan du behöva välja den i klockans systemmeny.",
                "select1": "Tryck och håll menyknappen på klockan (eller motsvarande knapp på pekskärmsenheter) för att öppna systemmenyn.",
                "select2": "Gå till «Watch Faces» eller «Display Designs».",
                "select3": "Bläddra i listan över installerade urbrickor med upp/ner-knapparna eller pekskärmen.",
                "select4": "Bekräfta vald urbricka med knappen uppe till höger – den är då aktiv på klockan."
            },
            "versions": {
                "title": "VX vs Elite – vad är skillnaden?",
                "sameFeatures": "Tekniskt är båda versionerna identiska med samma funktioner. De skiljer sig bara i hur de köps och aktiveras.",
                "eliteTitle": "Elite-version (Garmin Pay)",
                "elite1": "Egen installation av urbrickan köpt direkt via Garmin Pay i ConnectIQ Store.",
                "elite2": "Elite-versionen är kopplad till ditt Garmin-konto. Köper du en ny klocka kan du installera Elite-urbrickan igen utan extra nyckel.",
                "elite3": "Garmin Pay stöds inte på alla klockmodeller och är inte tillgängligt i alla länder.",
                "eliteNoKey": "Viktigt: Vid köp av Elite-version via Garmin Pay skickas ingen aktiveringskod. Elite-versionen låses upp direkt efter köp och kräver ingen kod.",
                "vxTitle": "VX / webbversion",
                "vx1": "Kompatibel med fler enheter och ofta tillgänglig när Garmin Pay inte stöds.",
                "vx2": "Har en inbyggd gratis provperiod på flera dagar.",
                "vx3": "Efter provperioden kan du köpa en aktiveringskod på denna webbplats för att låsa upp VX-versionen (eller pro-funktioner) permanent.",
                "vx4": "Aktiveringskoden gäller alltid bara enheten den köptes för (WatchfaceID).",
                "vx5": "Byts klockan av Garmin under garanti kan en ny nyckel genereras. Kontakta support via kontaktformuläret i så fall.",
            },
            "website": {
                "title": "Köp via webbplatsen (VX / vanliga versioner)",
                "step1": "Installera urbrickan på klockan först (se fliken Installation). WatchfaceID visas först i urbrickans inställningar efter installation.",
                "step2": "Öppna urbrickans inställningar (via ConnectIQ-appen eller Garmin Express) och kopiera WatchfaceID från översta fältet.",
                "step3": "Välj motsvarande urbricka på denna webbplats och ange WatchfaceID i köpformuläret.",
                "step4": "Slutför betalningen. Du får aktiveringskoden via e-post och kan ange den i nyckelfältet i urbrickans inställningar.",
                "noteNoAutoInstall": "Viktigt: Köp av aktiveringskod via webbplatsen installerar inte urbrickan automatiskt på klockan. Installationsstegen ovan måste göras manuellt."
            },
            "troubleshooting": {
                "installationTitle": "Installationsproblem (kö / fastnade uppdateringar)",
                "installationIntro": "Ibland misslyckas installationen, urbrickan stannar länge i kön eller ConnectIQ-appen visar oändliga uppdateringar.",
                "installationCause": "Detta beror vanligtvis på ConnectIQ-appen eller Garmin-tjänster, inte själva urbrickan.",
                "installationFix1": "Starta om klockan och ConnectIQ-appen på telefonen.",
                "installationFix2": "Försök installera igen och se till att telefonskärmen inte stängs av och att ConnectIQ-appen hålls öppen.",
                "garminPayTitle": "Garmin Pay-köp fastnar på «in progress»",
                "garminPayText": "Om ett Garmin Pay-köp i ConnectIQ Store stannar på «in progress» länge hanteras det helt av Garmin. Som utvecklare har vi inget inflytande på Garmin Pay. Kontakta officiell Garmin-support i så fall.",
                "noKeyTitle": "Jag fick ingen aktiveringsnyckel efter webbköp",
                "noKey1": "Kontrollera först skräppostmappen – e-post med nycklar hamnar ofta där.",
                "noKey2": "Ofta hindrar ett stavfel i e-postadressen leveransen. Hittar du inte e-posten, kontakta oss.",
                "noKey3": "och ange e-postadressen (och om möjligt WatchfaceID) du använde vid betalning.",
                "noKeyElite": "Obs: Vid köp av Elite-version direkt via Garmin Pay i ConnectIQ Store skickas ingen aktiveringskod. Elite-versionen låses upp direkt efter köp och kräver ingen kod."
            },
            "contactLink": "Kontaktformulär"
        },
        "timezones": {
            "title": "Tidszoner och UTC-förskjutning",
            "basicsTitle": "Vad är andra och tredje tidszon?",
            "basicsText": "På många urbrickor kan du konfigurera två extra tidszoner. De kallas vanligtvis «andra tidszon» och «tredje tidszon» och visas i egna fält på urbrickan.",
            "offsetTitle": "Konfigurera UTC-förskjutningar",
            "offsetIntro": "I urbrickans inställningar finns vanligtvis ett fält där du anger förskjutningarna för andra och tredje tidszon i minuter relativt UTC.",
            "offsetFormat": "Första värdet är förskjutning för andra tidszonen, andra värdet för tredje tidszonen. Värden anges i minuter, separerade med mellanslag. Plusstecken läggs inte till automatiskt – positiva värden skrivs utan +.",
            "exampleLabel": "Exempel:",
            "exampleExplanation": "Här har andra tidszonen förskjutning −4,5 timmar (−270 minuter) och tredje tidszonen +2 timmar (+120 minuter), båda relativt UTC.",
            "changeExample": "Vill du ändra andra tidszonen till t.ex. +6 timmar måste första värdet vara 360 (6 × 60). Med exemplet ovan blir det:",
            "advancedTitle": "Avancerade alternativ (A/B/C-suffix)",
            "advancedOptionalHint": "Detta avsnitt är valfritt. Endast relevant om urbrickan stöder A/B/C-format-suffix.",
            "advancedIntro": "Om urbrickan stöder dessa suffix står det i beskrivningen ovanför offset-fältet i inställningarna. Vid stöd hittar du en beskrivning i stil med:",
            "advancedExample": "UTC 2:a + 3:e tidszonsförskjutning i minuter (separera med mellanslag) (bokstäver efter offset: A - 12h-format, B - 24h-format, C - militärt format, tom - standard)",
            "advancedNote": "Dessa valfria bokstäver (A/B/C) styr visningsformatet för tidszonen på vissa urbrickor. Använd dem bara om det står i beskrivningen för urbrickan och du behöver annat tidsformat. För de flesta räcker numeriska offset utan bokstäver.",
            "exampleSectionTitle": "Steg för steg: Exempel för olika städer och format",
            "exampleIntro": "Exemplet visar hur du ställer in andra tidszon (t.ex. New York) och tredje tidszon (t.ex. Tokyo), och valfritt 12h- eller 24h-visning för varje.",
            "exampleStep1Title": "Steg 1: UTC-förskjutning för 2:a tidszonen",
            "exampleStep1Text": "Välj stad eller region för andra tidszonen. Räkna tidskillnad till UTC i minuter. Exempel: New York (EST, UTC−5) → −300 minuter. Ange detta som första värde i inställningsfältet.",
            "exampleStep2Title": "Steg 2: UTC-förskjutning för 3:e tidszonen",
            "exampleStep2Text": "Samma för tredje tidszon. Exempel: Tokyo (JST, UTC+9) → 540 minuter. Detta är andra värdet, separerat med mellanslag från det första.",
            "exampleOnlyOffsets": "Stöder inte urbrickan A/B/C-suffix är du klar. Ange:",
            "exampleStep3Title": "Steg 3: Valfritt format-suffix (A/B/C)",
            "exampleStep3Optional": "Detta steg är valfritt: Du kan utelämna suffix även om urbrickan stöder dem – då används standardformat. För att tvinga 12h, 24h eller militärt format per zon, sätt bokstaven direkt efter offset – inget mellanslag mellan offset och suffix.",
            "exampleStep3Text": "Exempel: 12-timmarsformat för New York (A) och 24-timmars för Tokyo (B):",
            "exampleStep3Note": "Utan suffix används urbrickans standard (ofta 24h). Om suffix stöds står det i beskrivningen ovanför offset-fältet.",
            "exampleFormatTitle": "Så visas tid med A, B, C",
            "exampleFormatIntro": "För samma tidpunkt skiljer sig visningen efter format (exempel: 2:a zon New York -300, 3:e zon Tokyo 540). Live förhandsvisning:",
            "zone2": "2:a zon",
            "zone3": "3:e zon",
            "exampleTableTitle": "Referens: UTC-förskjutningar för utvalda städer (minuter)",
            "exampleTableIntro": "Normaltid; sommartid kan avvika. Multiplicera timmar med 60."
        },
        "switchViews": {
            "title": "Switchviews och geststyrning",
            "wordLabel": "byt vy",
            "basicsTitle": "Vad är Switchviews?",
            "basicsText": "Många urbrickor kan visa olik information i samma skärmområde. Dessa sidor kallas ofta «Switchview» ({{wordLabel}}), «Switchview 2», «Top View 1/2», «Bottom View 1/2» eller liknande i inställningarna.",
            "proNote": "Ofta är dessa extra vyer pro-funktioner tillgängliga under provperioden och kräver aktiveringskod efteråt.",
            "gestureTitle": "Byta vy med handledsrörelse",
            "gestureIntro": "På klockor utan kompatibel pekskärm kan alternativa vyer bytas med en andra handledsrörelse.",
            "gestureStep1": "Lyft handleden som vanligt för att väcka skärmen. Sekunder eller ljusare skärm visar att klockan är aktiv.",
            "gestureStep2": "Gör samma rörelse igen inom några sekunder (ca 7) – inte för abrupt, men tydligt noch för att klockan ska registrera en andra gest.",
            "gestureStep3": "Stöder urbrickan Switchviews byts konfigurerade områden (t.ex. övre eller nedre vy) till nästa sida.",
            "gestureHint": "Händer inget, kontrollera inställningarna: vissa vyer måste tilldelas explicit (t.ex. «Top View 2» / «Bottom View 2»).",
            "touchTitle": "Switchviews på pekskärmsenheter",
            "touchIntro": "På nyare klockor med pekskärm (t.ex. Fenix 7 och nyare) kan vyer ofta också bytas via tryckzoner.",
            "touchConfig": "På många urbrickor konfigureras zonerna i inställningarna, ofta längre ner i listan. Typiskt är tim- och minutsiffrorna eller egna områden på skärmen.",
            "touchHold": "Är en tryckzon inställd byter långt tryck på siffra/område den tilldelade vyn.",
            "touchMultiple": "Vissa urbrickor har flera zoner – t.ex. en för övre och en för nedre vy.",
            "touchInfo": "Har en urbricka särskilda zoner beskrivs de vanligtvis på denna webbplats eller i ConnectIQ Store."
        },
        "findWfId": {
            "title": "Hitta WatchfaceID",
            "whatIs": "Vad är WatchfaceID?",
            "whatIsExplanation": "Varje urbricka har ett eget WatchfaceID per enhet – ett 5–6-siffrigt nummer. Det behövs för köp av aktiveringskod eller support.",
            "connectIqTitle": "Via ConnectIQ-appen (rekommenderas)",
            "ciq1": "Se till att klockan är ansluten till telefonen via Bluetooth.",
            "ciq2": "Öppna ConnectIQ-appen på telefonen.",
            "ciq3": "Gå till urbrickans sida med beskrivning och bilder. Använd sök eller «Mina urbrickor» under «Enhet» vid behov.",
            "ciq4": "Tryck «Inställningar» på urbrickans sida för att öppna alla inställningar.",
            "ciq5": "WatchfaceID visas i översta fältet. Kopieraa eller anteckna numret – det behövs vid betalning.",
            "keyEntryTitle": "Ange aktiveringsnyckel",
            "keyEntryExplanation": "Under WatchfaceID-fältet hittar du fält för nyckel/kod efter betalning. Vissa urbrickor visar återstående provtid där – radera det innan du anger koden.",
            "garminExpressTitle": "Via Garmin Express (dator)",
            "ge1": "Installera Garmin Express och anslut klockan till datorn.",
            "ge2": "Gå till listan över installerade urbrickor.",
            "ge3": "Klicka på tre-prickars-knappen vid urbrickan för att öppna inställningar.",
            "ge4": "Följ samma steg som i ConnectIQ-appen.",
            "geNote": "Obs: ConnectIQ-appen rekommenderas – vissa Garmin Express-versioner kan ge fel.",
            "zeroId": "WatchfaceID visar 0?",
            "zeroIdExplanation": "Ibland visas WatchfaceID som 0. Spara inställningarna en gång eller starta om klockan. Visar den fortfarande 0 fungerar betalningen vanligtvis ändå."
        },
        "location": {
            "title": "GPS och position",
            "whatIsGpsFix": "Vad är en GPS-fix?",
            "gpsFixExplanation": "En GPS-fix talar om för urbrickan var du är så att sol/måne, väderposition och tidvatten beräknas rätt.",
            "howTo": "Så gör du en GPS-fix",
            "step1": "Gå på klockan till startskärmen för en aktivitet (t.ex. «Löpning»).",
            "step2": "Vänta tills klockan har GPS-signal (grön linje/ikon).",
            "step3": "Gå tillbaka till urbrickan – data uppdateras inom några minuter.",
            "alternative": "Alternativ: telefon-GPS",
            "alternativeExplanation": "Du kan också aktivera GPS på telefonen. Klockan måste vara ansluten via Bluetooth. Metoden är långsammare men fungerar.",
            "requirements": "Krav",
            "req1": "Klocka ansluten till telefon via Bluetooth",
            "req2": "Garmin Connect-appen (inte ConnectIQ) minst i bakgrunden",
            "req3": "GPS aktiverat på telefonen för positionsbaserad användning"
        },
        "settings": {
            "tabs": {
                "options": "Datafältsalternativ",
                "change": "Ändra inställningar",
                "troubleshoot": "Felsökning"
            },
            "title": "Urbrickans inställningar",
            "optionsIntro": "Detta är den allmänna listan över alla datafältsalternativ. Klicka på ett alternativ för beskrivning. Observera att inte alla alternativ finns på alla urbrickor, eller kan ha något andra namn.",
            "change": {
                "title": "Så ändrar du urbrickans inställningar",
                "intro": "Urbrickans inställningar ändras via ConnectIQ-appen på telefonen.",
                "step1": "Anslut klockan till telefonen via Bluetooth och öppna ConnectIQ-appen (inte Connect-appen).",
                "step2": "Gå till urbrickans sida. Om den inte är installerad, installera den först.",
                "step3": "På urbrickans sida hittar du «Inställningar» – tryck för att öppna hela listan.",
                "step4": "Här kan du ändra datafält, färger och avancerade alternativ.",
                "step5": "Tryck på spara uppe till höger för att överföra inställningarna till klockan. Listan stängs efter sparning.",
                "installLink": "Installationsguide"
            },
            "troubleshoot": {
                "title": "Felsökning",
                "cantSave": {
                    "q": "Inställningar kan inte sparas – felmeddelande visas",
                    "a1": "Ibland har Garmin-servrar problem med vissa tecken.",
                    "a2": "Töm fältet för färgtema (om det finns) i inställningarna och spara igen – det löser vanligtvis problemet."
                },
                "wontOpen": {
                    "q": "Inställningarna öppnas inte",
                    "a1": "Stäng ConnectIQ-appen helt och starta om klockan vid behov.",
                    "a2": "Ser du bara «Installera» är urbrickan inte installerad på klockan ännu."
                },
                "missingOptions": {
                    "q": "Jag hittar inte ett visst inställningsalternativ",
                    "a": "Inte alla alternativ finns på alla enheter. Tillgänglighet beror på klockmodell och urbricka."
                },
                "naValue": {
                    "q": "Ett datafält visar bara «n/a»",
                    "a": "Enheten stöder inte detta alternativ – ofta för att modellen är äldre eller saknar hårdvara (t.ex. barometer, pulsoximeter)."
                }
            }
        },
        "dateFormat": {
            "title": "Anpassat datumformat (Datum 1 / 2 / 3)",
            "basicsTitle": "Vad är datumformatfälten?",
            "basicsIntro": "I urbrickans inställningar finns två fält (eller tre om urbrickan stöder det) för hur Datum 1, Datum 2 och eventuellt Datum 3 visas. Bokstäverna du skriver i varje fält styr formatet.",
            "notAll": "Detta finns inte på alla urbrickor.",
            "where": "Fälten för datumformat ligger vanligtvis längre ner i inställningarna, under datafältsalternativen.",
            "codesTitle": "Formatkoder",
            "codesIntro": "Du kan använda dessa bokstäver i formatfältet. Visningen följer dagens datum.",
            "codeD": "dag i månaden (med inledande nolla)",
            "codeDText": "dag som text (t.ex. måndag)",
            "codeM": "månad numeriskt (med inledande nolla)",
            "codeMText": "månad som text",
            "codeY": "år tvåsiffrigt",
            "codeY4": "år fyrsiffrigt",
            "codeJ": "julianskt datum (militärt)",
            "codeW": "veckonummer",
            "codeO": "månad utan inledande nolla",
            "codeN": "dag utan inledande nolla",
            "codeP": "dag på året",
            "exampleHint": "Exempel: «D, d.M.Y» kan visa «mån, 27.02.2026»."
        }
    },
    "newsletter": {
        "title": "Nyhetsbrev",
        "description": "Prenumerera för uppdateringar om nya urbrickor, funktioner och erbjudanden.",
        "frequencyHint": "Ungefär ett e-postmeddelande varannan månad. Du kan avsluta prenumerationen när som helst.",
        "emailPlaceholder": "Din e-postadresse",
        "subscribe": "Prenumerera",
        "unsubscribe": "Avsluta prenumeration",
        "subscribeSuccess": "Prenumeration lyckades! Kontrollera din e-post.",
        "subscribeError": "Ett fel uppstod. Försök igen senare.",
        "unsubscribeSuccess": "Avprenumeration lyckades.",
        "unsubscribeError": "Ett fel uppstod. Försök igen senare."
    },
    "contact": {
        "title": "Kontakt",
        "description": "Har du en fråga eller behöver support? Skicka mig ett meddelande.",
        "emailLabel": "E-post",
        "emailPlaceholder": "din@epost.se",
        "deviceLabel": "Enhet (valfritt)",
        "devicePlaceholder": "t.ex. Fenix 7",
        "watchfaceLabel": "Urbricka (valfritt)",
        "watchfacePlaceholder": "t.ex. Horizon",
        "messageLabel": "Meddelande",
        "messagePlaceholder": "Ditt meddelande …",
        "send": "Skicka meddelande",
        "sendAnother": "Skicka ett nytt meddelande",
        "successTitle": "Meddelande skickat!",
        "successMessage": "Jag återkommer så snart som möjligt.",
        "error": "Ett fel uppstod. Försök igen eller maila dev@orcatec.net direkt.",
        "rateLimit": "Högst 2 meddelanden per 5 minuter. Försök igen senare.",
        "consentNotice": "Genom att skicka godkänner du behandling av dina uppgifter enligt vår",
        "guidesIntro": "Har du frågor om specifika funktioner kan dessa guider redan innehålla svaret:",
        "faqIntro": "För många ämnen finns det också detaljerade FAQ:",
        "faqLinkLabel": "Öppna hjälp och instruktioner",
        "responseTimeNotice": "Observera att svarstiden under hög belastning ibland kan ta flera dagar."
    },
    "refund": {
        "title": "Återbetalningspolicy"
    },
    "terms": {
        "title": "Användarvillkor"
    },
    "privacy": {
        "title": "Integritetspolicy"
    },
    "footer": {
        "description": "Moderna Garmin-appar med avancerade funktioner för alla aktiviteter.",
        "tagline": "Moderna Garmin-appar med avancerade funktioner för alla aktiviteter.",
        "linksTitle": "Länkar",
        "socialsTitle": "Sociala medier",
        "terms": "Användarvillkor",
        "impressum": "Impressum",
        "privacy": "Integritet",
        "refund": "Återbetalningspolicy",
        "contact": "Kontakt",
        "rights": "Alla rättigheter förbehållna.",
        "links": "Länkar",
        "contactDescription": "Frågor eller support?",
        "contactLink": "Kontakta oss",
        "copyright": "Orcatec - TitanicTurtle. Alla rättigheter förbehållna.",
        "garminForums": "Garmin Forums"
    },
    "tides": {
        "title": "Tidvatten via Stormglass.io",
        "intro": "Om du vill använda tidvattenfunktionen på en urbricka med stormglass som leverantör måste du registrera dig på deras webbplats för att få en API-nyckel som du anger i motsvarande fält i urbrickans inställningar.",
        "apiKey": {
            "title": "Kopiera API-nyckel",
            "description": "Når du kopierer API-nyckelen, se till att alle tegn er med (vanligvis over 60) – noen ganger klipper Android/iOS bort en del etter «-»."
        },
        "freePlan": {
            "title": "Gratis plan",
            "description": "Den gratis (stormglass io)-planen gir 10 gratis forespørsler per dag, nok til tidvattensdata för støttede TitanicTurtle-urbrickor.",
            "note": "(Om urbrickan stöder stormglass io som väderleverantör och du vill använda det kan du behöva en annan prenumerationsplan)",
        },
        "dataDownload": {
            "title": "Datanedladdning",
            "description": "Vanligtvis laddas tidvattendata ned för flera dagar och uppdateras dagligen när telefonen är ansluten. Utan internet visas data minst i 3 (Horizon) / 5 (Centurion) dagar. (beror på urbricka/enhet)"
        },
        "initialSetup": {
            "title": "Första konfiguration",
            "description": "När du har angett stormglass io API-nyckeln i inställningarna kan det ta upp till 30 minuter innan data laddas ned och är tillgängliga.",
        },
        "locationUpdate": {
            "title": "Positionsuppdatering",
            "description": "Ändrar du position, sørg för GPS-signal på klokken slik at tidvattensdata oppdateres för den nye positionen."
        },
        "requirements": {
            "title": "Krav",
            "bluetooth": "Se till att klockan är ansluten till telefonen via Bluetooth och att Connect-appen (inte ConnectIQ) minst körs i bakgrunden.",
            "gps": {
                "title": "GPS-fix",
                "description": "Ser du en melding som «GPS?» på klokken, gör en GPS-fix slik at urbrickan kjenner positionen din.",
                "steps": {
                    "step1": "Gå till startskjermen för en aktivitet som «Löpning» på klokken",
                    "step2": "Vent til klokken har GPS-signal"
                }
            }
        }
    },
    "common": {
        "loading": "Laddar …",
        "error": "Feil",
        "retry": "Försök igen",
        "back": "Tillbaka",
        "close": "Stäng",
        "save": "Spara",
        "cancel": "Avbryt",
        "confirm": "Bekräfta",
        "notFound": "404 – Siden ble inte funnet"
    },
    "watchfacesOverview": {
        "title": "Alla appar",
        "loading": "Laster urbrickor …",
        "error": "Feil vid lasting av urbrickor",
        "retry": "Försök igen",
        "noWatchfaces": "Ingen urbrickor tillgänglig"
    },
    "detailTabs": {
        "payment": "Betalning",
        "themes": "Temaer",
        "info": "Info",
        "instructions": "Instruktioner",
        "instructionsIntro": "Alle guider på ett sted:",
        "noThemes": "Ingen färgteman för denna urbrickan."
    },
    "watchfaceDetail": {
        "loading": "Laddar urbricka …",
        "error": {
            "notFound": "Urbricke inte funnet",
            "loading": "Fel vid laddning av urbricka"
        },
        "backToOverview": "Tillbaka til översikten",
        "goToStore": "Gå till IQ Store",
        "goToTrial": "Provversjon",
        "devices": "enheter",
        "info": {
            "title": "Funktioner",
            "tides": "🌊 Tidvattensinformasjon med automatiske oppdateringer",
            "weather": "🌤️ Väderdata fra OpenWeatherMap och Yr",
            "colors": "🎨 Färgteman och tilpasninger",
            "location": "📍 GPS-basert positionsbestemmelse",
            "faq": "❓ FAQ och support",
            "weatherFallback": "Om en OpenWeatherMap API-nyckel anges utan Once Call 3.0-prenumeration finns en reserv till väderleverantören «Yr»."
        }
    },
    "themeInfo": {
        "howDoThemesWork": {
            "title": "Hur fungerar teman?:",
            "description": "Överst i urbrickans inställningar har du en «themestring» som representerer gällande fargeinställningar (ikoner, diagram, tid osv.). Ändrar du noe (f.eks. farge på övre delen) och trykker «Spara», oppdateres themestringen neste gang du öppnar inställningarna. Du kan lagre färgval vid å kopiere och lagre themestringen en annan plats, dele den (f.eks. i anmeldelser/forum) eller använda andras themestrings för att prova nye stiler."
        },
        "dynamicThemeSwitching": {
            "title": "Dynamiskt temabyte:",
            "sunset": {
                "title": "Byt efter solnedgång / före soluppgång -",
                "description": "Sätter du ett utropstegn ! foran themestringen du vill byta till i themestring-feltet, sparas den som tema efter solnedgång (eksempel: !UEUE[UEUEEEEEEU^). Du kan ändra när som helst med en themestring som starter med !. För att ta bort natt-tema, skriv bara ett enkelt ! i feltet – byts det inte längre."
            },
            "lowPower": {
                "title": "Byt i lågenergiläge -",
                "description": "Samma förfarande som solnedgång/soluppgång, men använd # i stället för ! framför temastrengen (exempel: #UEUE[UEUEEEEEEU^). Klockan går i «lågenergiläge» efter ~10 sekunder när du tittar på den / kommer tillbaka från en meny. Sekunder försvinner vanligtvis i lågenergi (kan ändras i inställningarna). Båda alternativen kan kombineras. En dynamisk temastreng syns inte i inställningarna när den är inställd – spara den någon annanstans om du vill ändra den senare."
            }
        }
    },
    "colorThemes": {
        "clickToCopy": "Klicka för att kopiera",
        "clickToPreview": "Klick för förhandsvisning",
        "closePreview": "Stäng förhandsvisning",
        "copied": "Kopierat!",
        "useInSettings": "Använd den i urbrickans inställningar",
        "guideLink": "Mer om teman och temastrengar",
        "deviceNote": "Obs: Färgteman er inte tillgänglig på alle enheter.",
        "noFieldNote": "Har inte urbrickans inställningar eget felt för färgteman, stöds de inte för din klockmodell på denna urbrickan."
    },
    "payment": {
        "option1": {
            "title": "Betalningsalternativ 1: Garmin Pay",
            "description": "Köp den betalte urbrickan direkte via Garmin Pay i ConnectIQ Store (hvis klokken stöds).",
            "link": "Länk till ConnectIQ Store"
        },
        "option2": {
            "title": "Betalningsalternativ 2: Direktbetalning via WatchfaceID",
            "description": "Stöds inte klockan av den betalte pro-versjonen, kan du köpa en prov/VX-nyckel genom att ange WatchfaceID.",
            "vxNote": "Detta är en nyckel för VX-versjonen av urbrickan, inte Garmin Pay-versionen!",
            "vxLink": "Länk till VX-versjon"
        },
        "tax": "moms",
        "wfid": {
            "description": "Ange WatchfaceID (finns i urbrickans inställningar)",
            "placeholder": "Ange WatchfaceID (5–6 siffer)",
            "guideLink": "Hur hittar jag WatchfaceID?",
            "guideLinkShort": "Vis guide"
        },
        "wfidError": {
            "letters": "WatchfaceID ska bara innehålla siffror",
            "tooLong": "WatchfaceID ska vara 5–6 siffer",
            "invalid": "Ange en giltig WatchfaceID (5–6 siffer)",
            "lengthHint": "WatchfaceID er vanligvis 5–6 siffer. Dubbelkolla."
        },
        "errors": {
            "empty": "Ange WatchfaceID",
            "invalid": "Ange en giltig WatchfaceID",
            "config": "Feil i betalningskonfigurasjon",
            "checkout": "Kunde inte öppna kassan. Försök igen."
        },
        "buy": "Köp nu",
        "selectMethod": "Välj version",
        "versionSelectHint": "Detta är två separata versioner — välj rätt:",
        "vxWarning": "VX- och Elite-versjonene er var för sig nedladdningsbara versioner av urbrickan. En aktiveringskode för VX låser INTE upp Elite-versjonen.",
        "beta": {
            "title": "För tiden i beta",
            "description": "I denna betafas kan du använda urbrickan helt gratis. Det tillkommer inga automatiska kostnader efter testfasen. Nya funktioner testas nu. Tack för feedback!",
            "descriptionApp": "Under den här betafasen kan du använda appen helt gratis. Efter testperioden tillkommer inga automatiska avgifter. Under den här fasen testas nya funktioner. Tack för er feedback!"
        },
        "elite": {
            "badge": "Garmin Pay",
            "title": "Elite-versjon",
            "description": "Denna urbricka är endast tillgänglig via Garmin Pay i ConnectIQ Store.",
            "comboDescription": "Köp direkt via Garmin Pay i ConnectIQ Store. Dette er en separat, fristående version.",
            "compatibility": "Obs: Inte alla klockmodeller stöder Garmin Pay. Kontrollera kompatibilitet på butikssidan. Ellers ladda ner VX-versjonen (teknisk identisk).",
            "storeLink": "Öppna i ConnectIQ Store",
            "moreGuide": "Mer om forskjellen mellom Elite- och VX-versjon?",
            "moreGuideLink": "Läs köps- och installationsguiden",
            "eliteNoKey": "Vid köp av Elite via Garmin Pay skickas ingen aktiveringskode. Elite låses upp direkt efter köp och kräver ingen kode.",
            "accountBound": "Köp via Garmin Pay är kopplat till Garmin-kontoen ditt och tillgänglig på framtida enheter (om kompatibla).",
            "eliteNoKeyAndGuide": "Vid köp via Garmin Pay skickas ingen aktiveringskode — Elite låses upp direkt efter köp. Mer i köps- och installationsguiden."
        },
        "vx": {
            "badge": "Alla enheter",
            "title": "VX-versjon",
            "description": "Kompatibel med alla enheter som stöds. Ladda ner gratis provversion fra ConnectIQ Store och aktivera här med köpt kod.",
            "trialNote": "VX-versjonen har gratis provperiod. Efter provperioden kan du köpe aktiveringskode nedan för permanent upplåsning.",
            "deviceBound": "En aktiveringskode är kopplad till enheten och låser upp VX permanent.",
            "moreGuide": "Mer om VX, nycklar eller installation?",
            "moreGuideLink": "Läs köps- och installationsguiden",
            "downloadLink": "Last ned VX-versjon",
            "details": {
                "line1": "Efter lyckad betalning skickas aktiveringsnyckeln til e-postadressen du anger i neste steg.",
                "line2": "Se till att e-postadressen är korrekt.",
                "line3": "Kontrollera skräppost efter betalning – nyckel-e-poster havner ofte der.",
                "line4": "Alle betalningsalternativer hanteras av Paddle – inget konto krävs.",
                "line5": "För support, använd kontaktformuläret eller ConnectIQ Store-verktyget.",
                "line6": "Andre henvendelser kan inte behandles."
            }
        },
        "standalone": {
            "title": "Köp aktiveringskode",
            "description": "Köp aktiveringskode genom att ange WatchfaceID nedan. Koden skickas direkt."
        },
        "checkoutOpening": "Öppnar kassan …",
        "info": {
            "key": "Efter köp får du en nyckel du kan ange i urbrickans inställningar.",
            "activation": "Nyckelen aktiveras omedelbart etter lyckad betalning.",
            "support": "Har du frågor, kontakt support.",
            "moreGuide": "Mer om köp och installation"
        },
        "methods": {
            "applePay": "Apple Pay",
            "googlePay": "Google Pay",
            "alipay": "Alipay",
            "paypal": "PayPal",
            "creditCard": "Kreditkort"
        }
    },
    "fonts": {
        "title": "Typsnitt",
        "timefonts": "Tidstypsnitt",
        "datafonts": "Datatypsnitt"
    },
    "weather": {
        "title": "Väderdataleverantörer",
        "intro": "På många urbrickor kan du välja olika väderdataleverantörer på de fleste enheter. Leverantör ändras i ConnectIQ-appens inställningar för urbrickan. Som standard är ofta Garmin-väder eller Yr valgt.",
        "noData": "Viser et väderdatafelt «no data», kunde inga väderdata laddas. Nedan hittar du steg för att få väderdata på klokken.",
        "tabs": {
            "garmin": "Garmin",
            "yr": "Yr",
            "openweathermap": "OpenWeatherMap",
            "visualcrossing": "Visual Crossing",
            "location": "Position"
        },
        "garmin": {
            "title": "Använda Garmin-väder:",
            "description": "Om enheten stöder Garmin-väder, anslut klockan till telefonen via Bluetooth och se till att Connect-appen (inte Connect IQ) minst körs i bakgrunden med tillgång till telefonens position. (GPS-position måste vara på)",
            "download": "Klockan laddar då väderdata fra tjenesten automatisk – kan ta några minuter.",
            "check": "Kontrollera om Garmin-väder-widgeten på klokken redan visar data. Utan data där kan inte urbrickan visa något heller – samma datakälla.",
            "noApiKey": "Ingen ekstra API-nyckel behövs för Garmin-väder.",
            "location": "På vissa urbrickor vises også medföljande position med Garmin-väder. Garmin-stasjoner är ofta närmaste flygplats – mer exakt platsangivelse kräver andra leverantörer.",
            "update": "Position uppdateras när positionsdata er aktive på telefonen.",
            "noData": "Om väderdata inte kan visas eller uppdateras, vises «no data» -> följ stegen ovan.",
            "missingData": {
                "title": "Data som inte ingår i Garmin-väder:",
                "airQuality": "Luftkvalitet",
                "uvIndex": "UV-indeks",
                "description": "Väderbeskrivning"
            }
        },
        "yr": {
            "title": "Använda Yr:",
            "description": "Yr leveres av Meteorologisk institutt och NRK och kan användas utan API-nyckel.",
            "setup": "För väderdata från Yr, välj det som leverantör och anslut klokken til telefonen via Bluetooth.",
            "connectApp": "På telefonen: Connect-appen (inte ConnectIQ) minst i bakgrunden – klokken hämtar bl.a. väderdata via den.",
            "interval": "Har urbrickan uppdateringsintervall är minimum 10 minutter med Yr som leverandør.",
            "noData": {
                "title": "no data / feil position:",
                "description": "Om väderdata inte laddas eller positionen är fel, uppdatera sparad position för urbrickan.",
                "fix": "Gå på klockan til startskjerm för en aktivitet som «Löpning» och vent på GPS-signal. Väder/position oppdateres inom minuter."
            },
            "missingData": {
                "title": "Data som inte ingår i Yr:",
                "airQuality": "Luftkvalitet"
            }
        },
        "openweathermap": {
            "title": "Använda OpenWeatherMap:",
            "description": "Om urbrickan stöder OpenWeatherMap och du vill använda det behöver du en gratis API-nyckel från deras webbplats:",
            "setup": "När du har nyckeln, skriv den inn i feltet i urbrickans inställningar. (Ny nyckel kan ta noen timer innan den fungerar)",
            "connect": "Anslut klockan till telefonen via Bluetooth och låt Connect-appen (inte Connect IQ) minst köras i bakgrunden för nedladdning av väderdata.",
            "gps": "Ser du «GPS?» på klokken, gör en GPS-fix. (Gå till startskärm för aktivitet som «Löpning» och vent på GPS-signal)",
            "uv": {
                "title": "UV-indeks / nederbörd på OpenWeatherMap:",
                "oldKey": "Om du har en äldre API-nyckel (før ~feb. 2023), kan du använda dessa värden uten problemer.",
                "newKey": "Om nyckeln är nyare och du vill se dessa värden från OpenWeatherMap, kan du behöva gratis abonnement «One Call by Call».",
                "limit": "De första 1000 förfrågningarna per dag er i praksis gratis; sätt gräns till 1000 – mer än tillräckligt för väderdata hela dagen på mina urbrickor."
            },
            "select": "Stöder urbrickan flera tredjepartsleverantörer, välj OpenWeatherMap i rullgardinsmenyn i inställningarna."
        },
        "visualcrossing": {
            "title": "Använda Visual Crossing:",
            "description": "Om du vill använda Visual Crossing, hämta en gratis API-nyckel på webbplatsen deres.",
            "setup": "Skriv in nyckeln i feltet i urbrickans inställningar och välj Visual Crossing som leverandør i menyen.",
            "connect": "Anslut klockan till telefonen via Bluetooth och låt Connect-appen (inte Connect IQ) minst köras i bakgrunden.",
            "gps": "Ser du «GPS?» på klokken, gör en GPS-fix. (Gå till startskärm för aktivitet som «Löpning» och vent på GPS-signal)"
        },
        "location": {
            "title": "Positionsuppdatering",
            "description": "För korrekt vädervisning behöver urbrickan din nuvarande position, bestämd via GPS.",
            "gpsFix": {
                "title": "Gör GPS-fix:",
                "description": "Ser du «GPS?» på klokken, måste du göra en GPS-fix så att urbrickan känner positionen.",
                "step1": "Gå på klockan til startskjerm för en aktivitet som «Löpning»",
                "step2": "Vent til klokken har GPS-signal",
                "step3": "Gå tillbaka till urbrickan – väderdata oppdateres inom minuter"
            },
            "requirements": {
                "title": "Krav:",
                "bluetooth": "Klokken måste vara ansluten til telefonen via Bluetooth",
                "connectApp": "Connect-appen (inte Connect IQ) måste minst köras i bakgrunden",
                "gps": "GPS måste vara aktiverat på telefonen"
            }
        }
    },
    "bierwander": {
        "title": "Bierwandern",
        "intro": "Bierwandern-appen låter dig spåra vandringen och påfyllningarna du njuter av längs vägen. Dessutom finns en promilleuppskattning med diagram (grovt anslag) – men ta det inte för seriöst!",
        "settingsHint": "På startskärmen trycker du på menykknappen på klockan för att öppna inställningar (på klockor med 2-knapps layout: tryck länge på pekskärmen).",
        "disclaimer": "Promilleberäkningen är ren underhållning – en algoritm som uppskattar alkohol i blodet baserat på intagen dryck och kroppsvikt! Fatta inga beslut baserat på detta värde – det är inte tillförlitligt och inte en riktig alkoholmätning!",
        "closing": "Annars önskar jag dig fina vandringar och trevlig stund!",
        "support": "Vid problem eller förbättringsförslag, använd knappen «App Support» – tack."
    },
    "bodysurf": {
        "intro": {
            "title": "Vad är BodySurf?",
            "text": "BodySurf är en Garmin Connect IQ-klockapp för bodysurfing. Den använder GPS för att upptäcka när du rider en våg, mäter distans och varaktighet för varje tur och ger en rolig titel baserat på distansen. Sessioner sparas som aktiviteter med individuella varv i Garmin Connect."
        },
        "gps": {
            "title": "Innan du börjar – GPS",
            "text1": "Vänta på GPS-fix innan du startar en session. På startskärmen visas \"Söker GPS\" tills signal finns, sedan \"START för att börja\".",
            "text2": "För bästa noggrannhet använder appen multi-GNSS / dual-band GPS när klockan stödjer det. Stå still en stund vid vattnet om fixen tar tid."
        },
        "start": {
            "title": "Startskärm",
            "startBtn": "Starta en ny session när GPS är redo (START = börja session).",
            "menuBtn": "Öppna inställningar: Hur man använder och Enheter (MENY = inställningar / info).",
            "backBtn": "BACK = avsluta app"
        },
        "during": {
            "title": "Under Aktivitet",
            "detect": "Ritter upptäckts av GPS hastighet automatiskt. Använd BACK för att starta/stopp en ridning manuellt. Korta rörelser under cirka 2 meter ignoreras.",
            "startBtn": "START = stoppa / spara / fortsätt",
            "backBtn": "BACK = manuell ridning på/av",
            "live": "Under riding ser du aktuell distans, live-titel och \"RIDNING!\". Efter en tur förblir titel och statistik synliga till nästa tur."
        },
        "stop": {
            "title": "Stoppmeny",
            "resume": "Fortsätt",
            "save": "Spara",
            "discard": "Kasta"
        },
        "after": {
            "title": "Efter Session",
            "summary": "Sammanfattningen visar sessionstid, antal Ritter, total distans och Bästa tur med titel och statistik.",
            "rides": "Svep för att se rittdetaljer. På knappklockor: << DOWN rides.",
            "finished": "Därefter: Ny Session med START eller Avsluta App med TILLBAKA."
        },
        "titles": {
            "title": "Tur-titlar",
            "intro": "Varje ridning får en rolig titel baserat på avstånd. Ju längre ridningen, desto bättre titel!",
            "colDistance": "Distans",
            "colTitle": "Titel",
            "th0": "Seegurke",
            "th1": "Flunder",
            "th2": "Mänsklig Surfbräda",
            "th3": "Vågsurfare",
            "th4": "Aquaman",
            "th5": "Poseidon",
            "th6": "Neptun",
            "th7": "Vågbesegrare",
            "th8": "Mästaridare",
            "th9": "Vågsgud",
            "th10": "Havets Legend",
            "th11": "Titan av Vågor",
            "th12": "Kung av Havet"
        },
        "connect": {
            "title": "Garmin Connect",
            "text": "Sparade sessioner visas i Garmin Connect med egna fält: tur-titel, varv-distans (meter), varv-tid (sekunder) och längsta tur/tid på sessionsnivå. Varje upptäckt tur sparas som ett varv."
        },
        "instinct": {
            "title": "Instinct 2 / 3 (MIP)",
            "layout": "På Instinct visar subdisplay tid, GPS och tur-distans. Använd NED-knappen istället för svep (<< DOWN rides).",
            "menu": "\"Meny\" visas till vänster på startskärmen. Tryck på START när GPS OK visas i subdisplay."
        },
        "settings": {
            "title": "Inställningar",
            "units": "Enheter: växla mellan metriskt och imperialiskt för distans och hastighet på klockan.",
            "info": "Info: inbyggd hjälp (Hur man använder) för knappar under aktivitet, efter session och på startskärmen."
        },
        "supportBefore": "Vid problem eller förslag använd",
        "supportLink": "kontaktformuläret",
        "supportAfter": " – tack!"
    }
};
